import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';
import { MenuItem } from 'primereact/menuitem';
import './DoctorMenu.css';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../reducers';
import useEffectOnce from '../../hooks/useEffectOnce';
import { fetchDoctorDatasss } from '../../reduxactions/doctoractions/DoctorProfileActions';

const defaultImage = require('../../assets/img/images.png');

const DoctorMenu = () => {
  const name = window.sessionStorage.getItem('username');
  const uid = window.sessionStorage.getItem('uid');
  const photo = window.sessionStorage.getItem('photo');
  const dispatch = useDispatch();
  const data = useSelector((state: RootState) => state.doctorprofile.data);
  const status = data[0]?.status;

  useEffectOnce(() => {
    const fetchDataAsync = async () => {
      try {
        await dispatch(fetchDoctorDatasss(uid) as any);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchDataAsync();
  }, [dispatch]);

  const items: MenuItem[] = [
    { label: 'Dashboard', icon: 'pi pi-gauge', url: '/medi/doctordashboard' },
    { label: 'Cases', icon: 'pi pi-list', url: '/medi/doctorcaseslists' },
    { label: 'Reports', icon: 'pi pi-file', url: '/medi/doctorreports' },
    { label: 'Appointments', icon: 'pi pi-user', url: '/medi/doctorappointments' },
    { label: 'Activities', icon: 'pi pi-bars', url: '/medi/doctoractivities' },
  ];

  const handleItemClick = (event: { item: { url?: string } }) => {
    if (event.item?.url) {
      window.location.href = event.item.url;
    }
  };

  return (
    <aside className="main-sidebar">
      {/* <div className="user-info">
        <img src={photo || defaultImage} className="avatar" alt="User" />
        <h2 className="username">{name}</h2>
      </div> */}

      <div className="menu" style={{margin:'0px 10px'}}>
        {status === 'APPROVED' ? (
          <PanelMenu
            model={items}
            // onClick={handleItemClick}
            className="doctor-panelmenu full-width"
            style={{backgroundColor:'#fff'}}
          />
        ) : (
          <p className="menu-message">Awaiting approval...</p>
        )}
      </div>
    </aside>
  );
};

export default DoctorMenu;
